import { DOCUMENT } from "@angular/common";
import { Inject, Injectable } from "@angular/core";
import { SwUpdate } from "@angular/service-worker";

@Injectable({ providedIn: "root" })
export class PwaUpdateService {
  /** Settles when the startup check/activate attempt finishes. */
  readonly ready: Promise<void>;

  constructor(private swUpdate: SwUpdate, @Inject(DOCUMENT) private document: Document) {
    this.ready = this.checkAndActivate();
    this.reloadWhenUnrecoverable();
  }

  private reloadWhenUnrecoverable(): void {
    if (!this.swUpdate.isEnabled) {
      return;
    }

    this.swUpdate.unrecoverable.subscribe(() => {
      this.document.location.reload();
    });
  }

  async checkAndActivate(): Promise<void> {
    if (!this.swUpdate.isEnabled) {
      return;
    }

    try {
      const updateReady = await this.swUpdate.checkForUpdate();
      if (!updateReady) {
        return;
      }

      const activated = await this.swUpdate.activateUpdate();
      if (activated) {
        this.document.location.reload();
      }
    } catch {
      // Quiet: SW update failures must not break marketplace bootstrap.
    }
  }
}
